<!-- Componente se utiliza para notificar operacion exitosa -->

<div class="pdt20 pdb10 pdl30 pdr30">
    <div fxLayout="column" fxLayoutAlign=" center">
        <mat-icon class="linkIcon ftxxxl green-5">check_circle_outline</mat-icon>
        <p class="mgt05 gray-10">Operación exitosa</p>
    </div>
</div>

